/** Copy for when the per-lease pet cap is full. Drafts consume slots server-side. */
export function leaseCapFullDraftHint(draftCount: number): string {
  if (draftCount > 0) {
    const label = draftCount === 1 ? 'draft' : 'drafts';
    return (
      `You have ${draftCount} saved ${label} on your dashboard. ` +
      'Delete an unused draft to free a slot, or tap Resume to finish that registration.'
    );
  }
  return (
    'Saved drafts count toward your pet limit. ' +
    'If you have drafts on your dashboard, delete unused ones to free a slot, or tap Resume to finish one.'
  );
}

export function leaseCapBlockedMessage(
  existing: number,
  maxPets: number,
  remaining: number,
  draftCount: number,
): string {
  if (remaining <= 0) {
    return (
      `This unit already has ${existing} pet(s) on file and the maximum allowed is ${maxPets}. ` +
      `${leaseCapFullDraftHint(draftCount)}`
    );
  }
  return (
    `This lease already has ${existing} pet(s) on file and the maximum allowed is ${maxPets}. ` +
    `You can register ${remaining} more pet(s) here. ` +
    `${leaseCapFullDraftHint(draftCount)}`
  );
}
